import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
import { useToast } from '@/components/ui/use-toast';

const Cancel = () => {
  const navigate = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    // Mostrar toast de cancelación
    toast({
      title: "Pago cancelado",
      description: "Puedes intentar nuevamente cuando lo desees",
      variant: "destructive",
    });

    // Redirigir al dashboard inmediatamente
    navigate('/dashboard');
  }, [navigate, toast]);

  // Este return casi nunca se verá porque la redirección es inmediata
  return (
    <div className="min-h-screen bg-gradient-to-b from-red-50 to-white flex items-center justify-center p-4">
      <motion.div 
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center"
      >
        <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Pago Cancelado
        </h1>
        <p className="text-gray-600">
          Redirigiendo al dashboard...
        </p>
      </motion.div>
    </div>
  );
};

export default Cancel;
